import Button from "components/button";
import ButtonIcon from "components/button-icon";
import { ConfigurationIcon, HistoryIcon } from "components/icons/icn-index.icon";
import IconControls from "components/icons/icn-controls.icon";
import pedidoPacoteIcon from "images/pedido-pacote.png";
import Paper from "material-ui/Paper";
import moment from "moment";
import PropTypes from "prop-types";
import { Component } from "react";
import intl from "react-intl-universal";
import { profileAdminOrMasterData } from "services/permissions/getPermissions";
import Fetch from "utils/fetch";
import { formatErrorMessage } from "utils/handle-error";
import Divisor from "../body-card/card-divisor";
import StatusCard from "./../body-card/status-card-generico";
import StyledConfiguracoesIntegracoes from "./styledConfiguracoesIntegracoes";
import FiltroIntegracaoGradeDescarga from "./filtros/filtro-integracao-grade-descarga";
import FiltroIntegracaoSugestaoAutomatica from "./filtros/filtro-integracao-sugestao-automatica";
import ModalConfirmacaoExecucaoIntegracao from "./modal-confirmacao-execucao-integracao";
import ModalAjustesTarefa from "./modal-ajustes-tarefa";
import ModalHistoricoExecucoes from "./modal-historico-execucoes";

const INTEGRACAO_CONTINUA = 1;
const INTEGRACAO_SUGESTOES_AUTOMATICAS = 4;
const INTEGRACAO_GRADE_DESCARGA_AMBEV = 14;
const INTEGRACAO_TAREFAS = 13;

const STATUS_STANDBY = 1;
const STATUS_AGENDADO = 2;
const STATUS_EM_EXECUCAO = 4;

//Status da integração
const STATUS_VERMELHO = { Id: 0, ColorStatus: "#ff5e53", ColorStatusArrow: "#c64138" }; // Parado = 0
const STATUS_CINZA = { Id: 1, ColorStatus: "#95a3b7", ColorStatusArrow: "#496072" }; // StandBy = 1
const STATUS_AZUL = { Id: 2, ColorStatus: "#6197C6", ColorStatusArrow: "#2870B2" }; // Agendado = 2
const STATUS_AMARELO = { Id: 3, ColorStatus: "#fbba49", ColorStatusArrow: "#c3913b" }; // Preparando Execucao = 3
const STATUS_VERDE = { Id: 4, ColorStatus: "#9bc73b", ColorStatusArrow: "#86ac32" }; // Em Execucao = 4

class ConfiguracoesIntegracoesCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalConfirmacaoExecucao: false,
      showModalAjusteTarefa: false,
      showModalHistorico: false,
      filters: null,
      avisoProximaExecucaoMinutos: null,
      integracao: props.integracao,
      configuracaoTarefa: {
        baseLineHorario: "",
        baselineSomenteSemana: false,
      },
    };
  }

  executeAndCloseModalConfirmacaoExecucao = (integracao) => {
    this.handleShowModalConfirmacaoExecucao();

    Fetch.post(`/integracao/salvarDadosIntegracao/`, {
      IdIntegracao: integracao.id ?? integracao.Id,
      Parametros: this.state.filters === null  ? null : JSON.stringify(this.state.filters)
    })
      .then(() =>
        this.props.proccessFeedback(
          intl.get("master-data.configurations.integrations.integrationScheduled")
        )
      )
      .then(() => this.props.obterIntegracoes())
      .catch((err) => {
        this.props.proccessFeedback(formatErrorMessage(err));
      });
  };

  handleShowModalConfirmacaoExecucao = () => {
    const { integracao } = this.state;
    const dataProximaExecucao = integracao.dataProximaExecucao ?? integracao.DataProximaExecucao;

    let avisoProximaExecucaoMinutos = null;
    if (dataProximaExecucao) {
      const diffMinutos = moment(dataProximaExecucao).diff(moment(), 'minutes');
      if (diffMinutos >= 0 && diffMinutos < 10) {
        avisoProximaExecucaoMinutos = diffMinutos;
      }
    }

    this.setState(prevState => ({
      showModalConfirmacaoExecucao: !prevState.showModalConfirmacaoExecucao,
      filters: null,
      avisoProximaExecucaoMinutos,
    }))
  }

  changeValue = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  generateFilters = (integracao, carteiras, familiasRotuladas) => {
    const id = integracao.id ?? integracao.Id;

    if (id === INTEGRACAO_SUGESTOES_AUTOMATICAS) {
      return (
        <FiltroIntegracaoSugestaoAutomatica
          familiasRotuladas={familiasRotuladas}
          changeValue={this.changeValue}
          IdFamiliaRotulada={
            this.state.filters !== null ? this.state.filters.IdFamiliaRotulada : null
          }
        />
      );
    }
    if (id === INTEGRACAO_GRADE_DESCARGA_AMBEV) {
      return (
        <FiltroIntegracaoGradeDescarga
          carteiras={carteiras}
          changeValue={this.changeValue}
          IdsCarteiras={this.state.filters !== null ? this.state.filters.IdsCarteiras : null}
        />
      );
    }
  };

  hasFilters = (integracao) => {
    const id = integracao.id ?? integracao.Id;
    return id === INTEGRACAO_SUGESTOES_AUTOMATICAS || id === INTEGRACAO_GRADE_DESCARGA_AMBEV;
  }

  toggleOpenModalHistorico = () => {
    this.setState(prevState => ({
      showModalHistorico: !prevState.showModalHistorico
    }))
  }

  toggleOpenModalAjusteTarefa = () => {
    if (!this.state.showModalAjusteTarefa) {
      this.searchSettingsIntegrationTasks();
    }

    this.setState((prevState) => ({
      showModalAjusteTarefa: !prevState.showModalAjusteTarefa,
    }));
  };

  searchSettingsIntegrationTasks = () => {
    Fetch.get(`/integracao/obterConfiguracoesIntegracaoTarefas`)
      .then((response) =>
        this.setState({
          configuracaoTarefa: {
            baseLineHorario: response.data.BaselineHorario,
            baselineSomenteSemana: response.data.BaselineSomenteSemana,
          },
        })
      )
      .catch((err) => this.props.proccessFeedback(formatErrorMessage(err)));
  };

  saveAjustesTarefa = () => {
    this.toggleOpenModalAjusteTarefa();

    const horario = this.state.configuracaoTarefa.baseLineHorario.split(":");
    Fetch.post(`/integracao/salvarConfiguracaoTarefas/`, {
      BaselineHora: horario[0],
      BaselineMinuto: horario[1],
      BaselineSomenteSemana: this.state.configuracaoTarefa.baselineSomenteSemana,
    })
      .then(() =>
        this.props.proccessFeedback(
          intl.get("master-data.configurations.integrations.integrationConfigured")
        )
      )
      .catch((err) => this.props.proccessFeedback(formatErrorMessage(err)));
  };

  changeValueTarefas = (prop, value) => {
    this.setState((prevState) => ({
      configuracaoTarefa: {
        ...prevState.configuracaoTarefa,
        [prop]: value,
      },
    }));
  };

  montagemStatus = (integracao) => {
    return (
      <div className="status-label">
        <span>Status: </span>
        <span>{integracao.descricaoStatus ?? integracao.DescricaoStatus}</span>
      </div>
    )
  }

  montaCorStatus = (integracao, ultimaExecucaoComErro) => {
    const status = integracao.status ?? integracao.Status;

    if (ultimaExecucaoComErro) {
      return STATUS_VERMELHO
    }
    if (status === STATUS_VERMELHO.Id) {
      return STATUS_VERMELHO
    }
    if (status === STATUS_CINZA.Id) {
      return STATUS_CINZA
    }
    if (status === STATUS_AZUL.Id) {
      return STATUS_AZUL
    }
    if (status === STATUS_AMARELO.Id) {
      return STATUS_AMARELO
    }
    if (status === STATUS_VERDE.Id) {
      return STATUS_VERDE
    }
    return STATUS_CINZA
  }

  render() {
    const {
      showModalConfirmacaoExecucao,
      showModalAjusteTarefa,
      showModalHistorico,
      integracao,
      configuracaoTarefa,
    } = this.state;

    const { carteiras, familiasRotuladas } = this.props;

    // Suporte a ambos os formatos de campo (camelCase novo e PascalCase antigo)
    const id = integracao.id ?? integracao.Id;
    const status = integracao.status ?? integracao.Status;
    const configurada = integracao.configurada ?? true; // jobs antigos sempre configurados
    const visivel = integracao.visivel ?? integracao.Visivel ?? true;
    const descricaoTipoIntegracao = integracao.descricaoTipoIntegracao ?? integracao.DescricaoTipoIntegracao;
    const dataUltimaExecucao = integracao.dataUltimaExecucao ?? integracao.DataUltimaExecucao;
    const dataProximaExecucao = integracao.dataProximaExecucao ?? integracao.DataProximaExecucao;

    const ultimaExecucaoComErro = integracao.ultimaExecucaoComErro ?? integracao.UltimaExecucaoComErro ?? false;

    return (
      <StyledConfiguracoesIntegracoes
        corStatus={this.montaCorStatus(integracao, ultimaExecucaoComErro)}
        ultimaExecucaoComErro={ultimaExecucaoComErro}
        naoConfigurada={!configurada}
        visivel={visivel}
      >
        <Paper
          zDepth={1}
          className="card-integracoes"
          style={{ height: `200px` }}
        >
          {ultimaExecucaoComErro && (
            <span className="last-execution-error-badge">
              {intl.get('master-data.configurations.integrations.lastExecutionError')}
            </span>
          )}
          <div className='card-area'>
            <div className='header-card'>
              <StatusCard
                Titulo={descricaoTipoIntegracao}
                SubTitulo={
                  <div>
                    {configurada ? this.montagemStatus(integracao) : (
                      <div className="status-label">
                        <span>{intl.get('master-data.configurations.integrations.notConfigured')}</span>
                      </div>
                    )}
                  </div>
                }
                Icon={visivel
                  ? pedidoPacoteIcon
                  : <ConfigurationIcon width="28px" height="28px" color="var(--color-contrast-white)" />
                }
                Status={configurada ? this.montaCorStatus(integracao, ultimaExecucaoComErro) : STATUS_CINZA}
              />
            </div>

            <Divisor />

            <div className="body-card">
              <div className="card-label">
                <span>
                  {intl.get('master-data.configurations.integrations.lastUpdate')}
                </span>
                <span>{
                  dataUltimaExecucao ? moment(dataUltimaExecucao).format("L LT")
                    : intl.get('master-data.configurations.integrations.notExecuted')
                }</span>
              </div>
              <div className="card-label">
                <span>{intl.get('master-data.configurations.integrations.nextExecution')}</span>
                <span>{dataProximaExecucao ? moment(dataProximaExecucao).format("L LT") : '-'}</span>
              </div>
                         
            </div>

            <Divisor />
            <div className="body-card">
              <div className="card-label"> 
                {!visivel && (
                      <div className="status-label background-job-label">
                        <span className="background-job-badge">· Background Job</span>
                      </div>
                    )}</div>
              <div className="card-actions">
                {id === INTEGRACAO_TAREFAS &&
                  <div title={intl.get('master-data.configurations.integrations.integrationAdjust')}>
                    <ButtonIcon
                      buttonIcon={<IconControls width={"32px"} height={"24px"} />}
                      buttonType="default"
                      className="icon-button"
                      onClick={this.toggleOpenModalAjusteTarefa}
                    />
                  </div>
                }

                {/* Botão Ver Histórico — disponível para todos os jobs */}
                <div title={intl.get('master-data.configurations.integrations.history')}>
                  <ButtonIcon
                    buttonIcon={<HistoryIcon width={24} height={24} />}
                    buttonType="default"
                    className="icon-button"
                    onClick={this.toggleOpenModalHistorico}
                  />
                </div>

                {/* Botão Executar — para jobs configurados em standby ou agendados */}
                {profileAdminOrMasterData() && configurada && id != INTEGRACAO_CONTINUA && (status === STATUS_STANDBY || status === STATUS_AGENDADO) &&
                  <div title={intl.get('master-data.configurations.integrations.execute')}>
                    <Button
                      buttonType="default"
                      value={intl.get('master-data.configurations.integrations.execute')}
                      className="execute-button"
                      onClick={this.handleShowModalConfirmacaoExecucao}
                    />
                  </div>
                }
              </div>
            </div>
          </div>
        </Paper>

        {showModalConfirmacaoExecucao && (
          <ModalConfirmacaoExecucaoIntegracao
            showModalConfirmation={showModalConfirmacaoExecucao}
            handleShowModal={this.handleShowModalConfirmacaoExecucao}
            executeAndCloseModal={() => this.executeAndCloseModalConfirmacaoExecucao(integracao)}
            descricaoIntegracao={descricaoTipoIntegracao}
            desabilitarBotaoOk={this.hasFilters(integracao) && this.state.filters === null}
            avisoProximaExecucaoMinutos={this.state.avisoProximaExecucaoMinutos}
          >
            {this.generateFilters(integracao, carteiras, familiasRotuladas)}
          </ModalConfirmacaoExecucaoIntegracao>
        )}

        {showModalAjusteTarefa &&
          <ModalAjustesTarefa
            openModalAjustesTarefa={showModalAjusteTarefa}
            toggleOpenModalAjustesTarefa={this.toggleOpenModalAjusteTarefa}
            handleSaveAjustesTarefa={this.saveAjustesTarefa}
            integracao={integracao}
            profileAdminOrMasterData={profileAdminOrMasterData()}
            configuracaoTarefa={configuracaoTarefa}
            changeValueTarefas={this.changeValueTarefas}
          />
        }

        {showModalHistorico &&
          <ModalHistoricoExecucoes
            open={showModalHistorico}
            onClose={this.toggleOpenModalHistorico}
            integracao={integracao}
            onFeedback={this.props.proccessFeedback}
          />
        }

      </StyledConfiguracoesIntegracoes>
    );
  }
}

ConfiguracoesIntegracoesCard.propTypes = {
  integracao: PropTypes.object.isRequired,
  proccessFeedback: PropTypes.func.isRequired,
  obterIntegracoes: PropTypes.func.isRequired,
  familiasRotuladas: PropTypes.array.isRequired,
  carteiras: PropTypes.array.isRequired,
};

export default ConfiguracoesIntegracoesCard;
